import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Wizard from "@/pages/Wizard";
import BookReader from "@/pages/BookReader";
import Library from "@/pages/Library";
import SharedReader from "@/pages/SharedReader";
import Samples from "@/pages/Samples";
import Admin from "@/pages/Admin";
import RefundPolicy from "@/pages/RefundPolicy";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import { Toaster } from "sonner";
import "@/App.css";

const Protected = ({ children }) => {
    const { user, ready } = useAuth();
    if (!ready) return null;
    if (!user) return <Navigate to="/auth" replace />;
    return children;
};

// The admin API already enforces this; the route guard just avoids rendering a
// console the user can't populate.
const AdminOnly = ({ children }) => {
    const { user, ready } = useAuth();
    if (!ready) return null;
    if (!user) return <Navigate to="/auth" replace />;
    if (user.role !== "admin") return <Navigate to="/" replace />;
    return children;
};

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-center" richColors />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/create" element={<Protected><Wizard /></Protected>} />
                    <Route path="/read/:id" element={<Protected><BookReader /></Protected>} />
                    <Route path="/library" element={<Protected><Library /></Protected>} />
                    <Route path="/samples" element={<Samples />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/shared/:token" element={<SharedReader />} />
                    <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
